import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Footer, BootomTab, TourPopUp, Assistant } from './Componets/index'
import { NotFound404, ScrollToTop, PageLoading, path } from "./base";

import { useDispatch } from "react-redux";
import { getTopCategory, getUserInfo } from "./redux/AppSlice";
import { ErrorBoundary } from './base/Handlers/ErrorBoundary';

// lazy load components
const Header = lazy(() => import('./Componets/Other/Header'));


// Lazy load pages per route
const Home = lazy(() => import('./Pages/Other/Home'));
const CreateUser = lazy(() => import('./Pages/User/CreateUser'));
const LoginUser = lazy(() => import('./Pages/User/LoginUser'));
const ForgotPassword = lazy(() => import('./Pages/User/ForgotPassword'));
const UserProfile = lazy(() => import('./Pages/User/UserProfile'));
const AllAddress = lazy(() => import('./Pages/Address/AllAddress'));
const AddAddress = lazy(() => import('./Pages/Address/AddAddress'));
const UpdateAddress = lazy(() => import('./Pages/Address/UpdateAddress'));
const WishList = lazy(() => import('./Pages/User/WishList'));
const ProductDetail = lazy(() => import('./Pages/Product/ProductDetail'));
const AllShop = lazy(() => import('./Pages/Shop/AllShop'));
const ShopDetail = lazy(() => import('./Pages/Shop/ShopDetail'));
const AllProduct = lazy(() => import('./Pages/Product/AllProduct'));
const ProductSearch = lazy(() => import('./Pages/Product/ProductSearch'));
const Cart = lazy(() => import('./Pages/Order/Cart'));
const AllOrder = lazy(() => import('./Pages/Order/AllOrder'));
const OrderPlaced = lazy(() => import('./Pages/Order/OrderPlaced'));
const BuyNow = lazy(() => import('./Pages/Order/BuyNow'));
const OrderDetail = lazy(() => import('./Pages/Order/OrderDetail'));
const Payment = lazy(() => import('./Pages/Other/Payment'));
const Install = lazy(() => import('./Pages/Other/Install'));
const AllInquiry = lazy(() => import('./Pages/Wholesale/AllInquiry'));
const InquiryCart = lazy(() => import('./Pages/Wholesale/InquiryCart'));
const InquiryDetails = lazy(() => import('./Pages/Wholesale/InquiryDetails'));
const InquirySubmited = lazy(() => import('./Pages/Wholesale/InquirySubmited'));
const About = lazy(() => import('./Pages/Other/About'));
const ContactUs = lazy(() => import('./Pages/Other/ContactUs'));
const Policy = lazy(() => import('./Pages/Other/Policy'));
const TermsService = lazy(() => import('./Pages/Other/TermsService'));
const LoadingScreen = lazy(() => import('./Pages/Other/LoadingScreen'));
const TourGuide = lazy(() => import('./Pages/Other/TourGuide'));

// demo
const DemoCategory = lazy(() => import('./Pages/Product/DemoCategory'));
const DemoImages = lazy(() => import('./Pages/Product/DemoImages'))

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    const header = document.getElementsByTagName('header')[0]

    const handleScroll = () => {
      header && (window.scrollY > 50 ? header.classList.add('addShadow') : header.classList.remove('addShadow'))
    };

    // add an event for headar 
    window.addEventListener('scroll', handleScroll);

    dispatch(getUserInfo())
    dispatch(getTopCategory())

    return () => window.removeEventListener('scroll', handleScroll)
  }, [dispatch])



  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<LoadingScreen />} >
          <ScrollToTop />
          <TourPopUp/>
          <PageLoading />
          <Header />
          <Routes>
            <Route path={path.home} element={<Home />}></Route>
            <Route path={path.create_user} element={<CreateUser />}> </Route>
            <Route path={path.login_user} element={<LoginUser />}> </Route>
            <Route path={path.forgot_password} element={<ForgotPassword />}></Route>
            <Route path={path.user_profile} element={<UserProfile />} ></Route>
            <Route path={path.all_address} element={<AllAddress />} ></Route>
            <Route path={path.add_address} element={<AddAddress />} ></Route>
            <Route path={path.update_address} element={<UpdateAddress />} ></Route>
            <Route path={path.wishlist} element={<WishList />} ></Route>
            <Route path={path.product_detail} element={<ProductDetail />}></Route>
            <Route path={path.all_shop} element={<AllShop />}></Route>
            <Route path={path.shop_detail} element={<ShopDetail />}></Route>
            <Route path={path.all_product} element={<AllProduct />}></Route>
            <Route path={path.cart} element={<Cart />}></Route>
            <Route path={path.order_placed} element={<OrderPlaced />}></Route>
            <Route path={path.product_search} element={<ProductSearch />}></Route>
            <Route path={path.about} element={<About />}></Route>
            <Route path={path.contact_us} element={<ContactUs />}></Route>
            <Route path={path.policies} element={<Policy />}></Route>
            <Route path={path.termsofservice} element={<TermsService />}></Route>
            <Route path={path.all_order} element={<AllOrder />} > </Route>
            <Route path={path.buy_now} element={<BuyNow />}> </Route>
            <Route path={path.order_detail} element={<OrderDetail />} ></Route>
            <Route path={path.payment} element={<Payment />} ></Route>
            <Route path={path.install} element={<Install />}></Route>
            <Route path={path.inquiry_cart} element={<InquiryCart />}></Route>
            <Route path={path.all_inquiry} element={<AllInquiry />}></Route>
            <Route path={path.inquiry_detail} element={<InquiryDetails />}></Route>
            <Route path={path.inquiry_submited} element={<InquirySubmited />}></Route>
            <Route path={path.tour_guide} element={<TourGuide />}></Route>
            
            {/* demo */}
            <Route path={path.demo_category} element={<DemoCategory />}></Route>
            <Route path='/demo/category/:id/images/' element={<DemoImages/>}></Route>

            <Route path='*' element={<NotFound404 />}></Route>
          </Routes>
          <BootomTab />
          <Assistant/>
          <Footer />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default App;